@if (hasFiltersSelected) {
<div class="m-5">
  <atx-empty-placeholder class="mt-4" [icon]="['fas', 'circle-exclamation']">
    <ng-container title>
      <span
        i18n="
          AnalyticsDashboard|Analytics Dashboard No Data Available title with
          filters@@analyticsDashboardNoDataAvailableTitleWithFilters"
      >
        No results...
      </span>
    </ng-container>
    <ng-container
      msg
      i18n="
        AnalyticsDashboard|Analytics Dashboard No Data Available Description
        with filters@@analyticsDashboardNoDataAvailableDescriptionWithFilters"
    >
      Try removing some of the filters.
    </ng-container>
    <button
      class="btn btn-link text-primary"
      i18n="AnalyticsDashboard|Clear filtersh@@clearAnalyticsFiltersButton"
      (click)="clearFilters.emit()"
    >
      Clear Filters
    </button>
  </atx-empty-placeholder>
</div>
} @else {
<atx-empty-placeholder class="mt-4" [icon]="['fas', 'circle-exclamation']">
  <ng-container
    title
    i18n="
      AnalyticsDashboard|Analytics Dashboard No Data Available
      title@@analyticsDashboardNoDataAvailableTitle"
    >No Data Available</ng-container
  >
  <ng-container
    msg
    i18n="
      AnalyticsDashboard|Analytics Dashboard No Data Available
      Description@@analyticsDashboardNoDataAvailableDescription"
  >
    There is no data available to show.
  </ng-container>
</atx-empty-placeholder>
}
